import React from 'react';
import Navbar from '../components/Navbars/AppNavbar.js';
import Footer from '../components/Footers/Footer.js';
import FooterSM from '../components/Footers/FooterSmall.js';
import ArtistsComponent from '../components/Artists/index';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

export default function Artists() {
  const SEO = {
    title: 'MusicArt | MusicArtists',
    description: 'Search for Artists',
    canonical: 'https://musicart.io/artists',
  };
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        {/* <Link  rel="canonical" href="https://musicart.io/artists" /> */}
      </Head>
      <NextSeo {...SEO} />
      <Navbar transparent />
      <ArtistsComponent />
      <Footer />
      <FooterSM />
    </>
  );
}
